<script setup lang="ts">
  import { getCurrentInstance, ref } from 'vue'

  withDefaults(defineProps<{
    buttonTextIfExpanded?: string,
    buttonTextIfNotExpanded?: string,
  }>(), {
    buttonTextIfNotExpanded: 'Les mer',
    buttonTextIfExpanded: 'Les mindre'
  })

  const instance = getCurrentInstance()
  const uuid = instance?.uid.toString()
  const isOpen = ref<boolean>(false)
</script>

<template>
  <template v-if="!!$slots.content">
    <button
      class="toggle-button"
      :aria-expanded="isOpen"
      :aria-controls="`content-${uuid}`"
      @click="isOpen = !isOpen"
    >
      <slot
        name="toggle-button"
        :is-open="isOpen"
      >
        {{ isOpen ? buttonTextIfExpanded: buttonTextIfNotExpanded }}
      </slot>
    </button>
    <Transition name="content-transition">
      <div
        v-if="isOpen"
        class="content-wrapper"
      >
        <div
          :id="`content-${uuid}`"
          class="content"
        >
          <slot name="content" />
        </div>
      </div>
    </Transition>
  </template>
</template>

<style scoped lang="scss">
  .toggle-button {
    display: inline;
    margin: 0;
    cursor: pointer;
    border: 0;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    text-decoration: underline;
    text-decoration-color: inherit;
    text-decoration-thickness: 2px;
    text-underline-offset: 5px;
    background: none;
    padding: 0;
    transition: text-decoration-color .3s ease-in-out;

    @include vgs-media-hover {
      text-decoration-color: transparent;
    }

    @include visible-focus-ring;
  }

  .content-transition-enter-to,
  .content-transition-leave-from {
    transition: all .3s ease-in-out;
    max-height: 800px;
    opacity: 1;
  }

  .content-transition-enter-from,
  .content-transition-leave-to {
    transition: all .3s ease-in-out;
    max-height: 0;
    opacity: 0;
  }

  .content-wrapper {
    max-height: auto;
  }

  .content {
    @include caption;

    font-weight: 400;
    padding: 24px 0;
  }
</style>
